/**
 * Служебная строка ошибки для отчёта поддержке: код и номер запроса (корреляция). Одна сборка вместо копий в пакетах;
 * формат прежний — «Код: X · запрос Y», а без номера запроса — «Код: X».
 */

/** Что нужно от ошибки; структурно подходит `ErrorView` клиентской среды выполнения, ui-kit её не импортирует. */
export interface ErrorMetaSource {
  code: string
  correlationId: string | null
}

export interface ErrorMetaOptions {
  /** Строка нужна только при номере запроса: без него `undefined` (так делали окна, где один код отчёту не помогает). */
  requestIdRequired?: boolean
}

export function errorMeta(error: ErrorMetaSource | null | undefined, options: ErrorMetaOptions = {}): string | undefined {
  if (error === null || error === undefined) return undefined
  if (error.correlationId !== null) return `Код: ${error.code} · запрос ${error.correlationId}`
  return options.requestIdRequired === true ? undefined : `Код: ${error.code}`
}
